import React from 'react';
import pick from 'lodash/pick';
import SelectField from 'components/pure/utils/form/SelectField';
import ScheduleDescription from './ScheduleDescription';
import range from 'lodash/range';
import {validate} from 'records/CoachingPlan';
import FieldContainer from 'components/pure/utils/form/FieldContainer';
import './DurationStep.styl';

const minuteOptions = range(15, 121, 15).map(i => ({
  label: i + '',
  value: i,
}));

export default class DurationStep extends React.PureComponent {
  static title = 'Duration';

  static validate(plan) {
    return pick(validate(plan).schedule, ['durationInMinutes']);
  }

  render() {
    const {model: coachingPlan, onChange, showErrors} = this.props;
    const {schedule} = coachingPlan;
    const errors = DurationStep.validate(coachingPlan);
    return (
      <div className="coaching-step coaching-plan-wizard-duration-step">
        <ScheduleDescription schedule={schedule} />
        <p>How long should each meeting last?</p>
        <FieldContainer labelType="div" error={showErrors ? errors.durationInMinutes : null}>
          <SelectField
            value={schedule.durationInMinutes}
            hideResetButton={true}
            options={minuteOptions}
            tether={true}
            onChange={value =>
              onChange(coachingPlan.set('schedule', schedule.set('durationInMinutes', value)))
            }
          />
          minutes
        </FieldContainer>
      </div>
    );
  }
}
